import { render, staticRenderFns } from "./CoproductionTerms.vue?vue&type=template&id=95b2a782&scoped=true&"
var script = {}
import style0 from "./CoproductionTerms.vue?vue&type=style&index=0&id=95b2a782&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b2a782",
  null
  
)

export default component.exports